<template>
    <Card title="Updates">
      <div class="text-gray-600 text-sm mb-4">Latest system changes and feature launches</div>
      <div class="space-y-3">
        <div>
          <div class="flex items-center justify-between">
            <span class="font-semibold text-gray-900">SLA Uptime Improved</span>
            <span class="bg-gray-100 text-gray-700 rounded-full px-2 py-0.5 text-xs">Today</span>
          </div>
          <div class="text-gray-500 text-xs">Uptime commitment raised to 99.99% for all production plans.</div>
        </div>
        <div>
          <div class="flex items-center justify-between">
            <span class="font-semibold text-gray-900">Feature Deployment</span>
            <span class="bg-gray-100 text-gray-700 rounded-full px-2 py-0.5 text-xs">Yesterday</span>
          </div>
          <div class="text-gray-500 text-xs">Real-time analytics now available for all users.</div>
        </div>
        <div>
          <div class="flex items-center justify-between">
            <span class="font-semibold text-gray-900">Security Audit Passed</span>
            <span class="bg-gray-100 text-gray-700 rounded-full px-2 py-0.5 text-xs">2 days ago</span>
          </div>
          <div class="text-gray-500 text-xs">SOC2 Type II certification achieved for this year.</div>
        </div>
      </div>
    </Card>
  </template>

<script>
import Card from '../../Card.vue'
export default {
  name: 'UpdatesCard',
  components: { Card }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/StatCards/ReccomendationsRow/UpdatesCard.vue